import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { UserService } from '@app/shared/_services/user.service';
import { UserAuthService } from '@shared/_services/user-auth.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-profil-bar',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './profil-bar.component.html',
  styleUrl: './profil-bar.component.css'
})
export class ProfilBarComponent {

  constructor(private authenticationSvc: UserAuthService,
    private router: Router,
    private userSvc: UserService,
    // private toastr: ToastrManager
  ) {
  }
  triggerLogout() {
    const self = this;
    Swal.fire({
      title: 'Logout',
      text: 'Do you want to logout of your account?',
      icon: "info",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#dc3545', // Green color for Yes button
      cancelButtonColor: '#9b9b9b',  // Red color for No button
    }).then((result: any) => {
      /* Read more about isConfirmed, isDenied below */
      console.log(result.isConfirmed);
      if (result.isConfirmed) {
        console.log(result);
        this.logout();
      }
    });
  }


  logout() {
    this.authenticationSvc.signOut();
    this.router.navigate(['/login']);

  }

}
